<div *ngFor="let row of rows"
     class="row"
     [ngClass]="{'is-list': isList}"
>
    <div class="ghost-item-animated"></div>
</div>
